
export const LivelloAutorizzazioneOptions: OptionType[] = [
    { label: 'Siaer', value: 0},
    { label: 'Provincia', value: 1},
    { label: 'Ufficio', value: 2},
    { label: 'Azienda', value: 3},
]
export const LivelloAutorizzazioneProvinciaOptions: OptionType[] = [
    { label: 'Provincia', value: 1},
    { label: 'Ufficio', value: 2},
    { label: 'Azienda', value: 3},
]
export const LivelloAutorizzazioneUfficioOptions: OptionType[] = [
    { label: 'Ufficio', value: 2},
    { label: 'Azienda', value: 3},
]
export const LivelloAutorizzazioneAziendaOptions: OptionType[] = [
    { label: 'Azienda', value: 3},
]
export interface ILivelloAutorizzazioneContextsOptions {
    [key: string]: OptionType[];
}
export const LivelloAutorizzazioneContextsOptions: ILivelloAutorizzazioneContextsOptions = {
    'siaer': LivelloAutorizzazioneOptions,
    'provincia': LivelloAutorizzazioneProvinciaOptions,
    'ufficio': LivelloAutorizzazioneUfficioOptions,
    'azienda': LivelloAutorizzazioneAziendaOptions,
}

export type OptionType = {
    label: string,
    value: string | number,
}
export const TypePersonaFisica: string = "PF"
export const TypeSocieta: string = "SC"

const Constants = {
    PageEditCompanyContentMaxWidth: 960,
    PageEditAgencyContentMaxWidth: 960,
    PageEditPrincipalContentMaxWidth: 960,
    PageEditWhatsNewContentMaxWidth: 960
    // TipoAutorizzazione,
    // LivelloAutorizzazione,
}

export const tabs = ['Inserimento Dati', 'Forfetario + Irpef', 'Irpef normale', 'Confronto', 'Report'];
export const tabsFlatTax = ['Inserimento Dati', 'Flat tax + irpef', 'Tutto irpef', 'Report'];
export const tabsSimulazioniSrl = ['Inserimento Dati', 'Normale', 'Solo compenso', 'Solo dividendi', 'Compensi e Dividendi', 'S.r.l trasparente', 'Trasparente e Compensi', 'Riepilogo'];
export const tabsSchedaBudget = ['Costi di avvio', 'Conto economico', 'Forfetario', 'Help'];
export const drawerWidth = 240;
export const drawerMobileWidth = 100;
export const breakpoint = 800;

export default Constants;